import { Injectable, EventEmitter } from '@angular/core';
//import { User, UserManager, UserManagerSettings } from 'oidc-client';
import { Observable, from, BehaviorSubject, map } from 'rxjs';

import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { combineLatest } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';

export class UsermanagerSettings {
  authority: string;
  client_id: string;
  redirect_uri: string;
  silent_redirect_uri: any;
  post_logout_redirect_uri: string;
  scope: string;
  prompt: string;
}


@Injectable()
export class AuthService {/*mgr: UserManager;
  userLoadededEvent: EventEmitter<User> = new EventEmitter<User>();
  currentUser: User;
  loggedIn = false;*/

  authHeaders: Headers;

  username = new BehaviorSubject(null);
  accesstoken = new BehaviorSubject(null);
  isMobileDevice = new BehaviorSubject(null);
  enhancedUserData$;
  claims = new BehaviorSubject(null);

  constructor(private router: Router, private http: HttpClient, private oidcSecurityService: OidcSecurityService) {
    const settings = {
      authority: environment.openIdConnectSettings.authority,
      client_id: environment.openIdConnectSettings.client_id,
      redirect_uri: environment.openIdConnectSettings.redirect_uri,
      silent_redirect_uri: environment.openIdConnectSettings.silent_redirect_uri,
      post_logout_redirect_uri: environment.openIdConnectSettings.post_logout_redirect_uri,
      response_type: environment.openIdConnectSettings.response_type,
      automaticSilentRenew: environment.openIdConnectSettings.automaticSilentRenew,
      accessTokenExpiringNotificationTime: environment.openIdConnectSettings.accessTokenExpiringNotificationTime,
      scope: environment.openIdConnectSettings.scope,
      prompt: environment.openIdConnectSettings.prompt,
    };

    
   // console.log('authority: ', JSON.stringify(settings));
    /*this.mgr = new UserManager(settings);

    this.mgr.getUser()
      .then((user) => {
        if (user) {
          this.loggedIn = true;
          this.currentUser = user;
          this.username.next(this.currentUser.profile.name);
          this.accesstoken.next(this.currentUser.access_token);
          this.userLoadededEvent.emit(user);

          sessionStorage.setItem('new', '4');
        } else {
          this.loggedIn = false;
        }
      })
      .catch((err) => {
        console.log("Error på rad 68 i auth.service.js: " + err);
        this.loggedIn = false;
      });*/



    // Förnya access_token när den gamla gått ut. Prenumeration på accesstoken görs i httpconfiginterceptor
   /* this.mgr.events.addAccessTokenExpiring(() => {

      this.mgr.signinSilent().then((user) => {

        this.accesstoken.next(user.access_token);
      //  console.log(user.expired);
      }).catch(function (err) {


       if (this?.mgr) {
        this.mgr.awaiting_token = false;
        this.mgr.handleSilentTimeout();
       } else {
         this.router.navigate(['']);
       }
       // alert('Time out...');
      });
    });

    this.mgr.events.addUserLoaded((user) => {
      this.currentUser = user;
      this.loggedIn = !(user === undefined);
    });

    this.mgr.events.addUserUnloaded(() => {
      this.loggedIn = false;
    });
*/
    this.enhancedUserData$ = combineLatest([
    this.oidcSecurityService.userData$,
    this.oidcSecurityService.getIdToken()
  ]).pipe(
    map(([userDataResult, idToken]) => {
  

  if (!idToken || typeof idToken !== 'string') {
    console.warn('Ingen giltig idToken tillgänglig – hoppar över decoding');
    return {
      ...userDataResult.userData,
      claims: []
    };
  }

  const decoded = jwtDecode<Record<string, any>>(idToken);

  const standardFields = [
    'aud', 'exp', 'iat', 'iss', 'nbf', 'jti', 'sub', 'nonce', 'auth_time', 'azp', 'at_hash', 'oi_au_id', 'oi_tkn_id'
  ];

  const claims = Object.entries(decoded)
    .filter(([key]) => !standardFields.includes(key))
    .map(([type, value]) => ({ type, value }));

  return {
    ...userDataResult.userData,
    claims
  };
})
  );
  
  }

  
  isLoggedInObs() {
    return this.oidcSecurityService.userData$ ? true : false;
    //return false;
   /* return from(this.mgr.getUser().then((user) => {
      console.log("user: ", user);
      if (user) {

        return true;
      } else {
        return false;
      }
    }));*/

  }

  clearState() {
   /* this.mgr.clearStaleState().then(function () {
   //   console.log('clearStateState success');
    }).catch(function (e) {
    //  console.log('clearStateState error', e.message);
    });*/
  }



  public logout(): void {
this.oidcSecurityService.logoffAndRevokeTokens().subscribe((result) => console.log(result));
   //  return this.mgr.signoutRedirect();
  }



  getUser() {

   /* this.mgr.getUser().then((user) => {
      this.currentUser = user;
    //  console.log('got user', user);
      this.userLoadededEvent.emit(user);
    }).catch(function (err) {
      console.log(err);
    });*/
  }

  removeUser() {
   /* this.mgr.removeUser().then(() => {
      this.userLoadededEvent.emit(null);
     // console.log('user removed');
    }).catch(function (err) {
      console.log(err);
    });*/
  }

  startSigninMainWindow() {

    window.sessionStorage.removeItem('selectedrole');

    
   /* this.mgr.signinRedirect({ data: '..' + localStorage.getItem('url') }).then(function () {
  
    }).catch(function (err) {

      console.log(err);
    });*/
  }
  endSigninMainWindow() {
  /*  this.mgr.signinRedirectCallback().then(function (user) {

    }).catch(function (err) {
      console.log(err);
    });*/
  }

  startSignoutMainWindow() {

/*
    this.mgr.getUser().then(user => {
if (user) {
      return this.mgr.signoutRedirect({ id_token_hint: user.id_token }).then(resp => {

        this.router.navigate(['/unauthorized']);
      }).catch(function (err) {
        console.log(err);
      });
    } else {
      this.router.navigate(['/unauthorized']);
    }

    });*/
  }

  endSignoutMainWindow() {

  /*  this.mgr.signoutRedirectCallback().then(function (resp) {
     // console.log('signed out', resp);
    }).catch(function (err) {
      console.log(err);
    });*/
  }
  /**
   * Example of how you can make auth request using angulars http methods.
   * @param options if options are not supplied the default content type is application/json
   */
  /*AuthGet(url: string, options?: RequestOptions): Observable<Response> {

    if (options) {
      options = this._setRequestOptions(options);
    } else {
      options = this._setRequestOptions();
    }
    return this.http.get(url, options);
  }*/
  /**
   * @param options if options are not supplied the default content type is application/json
   */
  /*AuthPut(url: string, data: any, options?: RequestOptions): Observable<Response> {

    const body = JSON.stringify(data);

    if (options) {
      options = this._setRequestOptions(options);
    } else {
      options = this._setRequestOptions();
    }
    return this.http.put(url, body, options);
  }*/
  /**
   * @param options if options are not supplied the default content type is application/json
   */
  /*AuthDelete(url: string, options?: RequestOptions): Observable<Response> {

    if (options) {
      options = this._setRequestOptions(options);
    } else {
      options = this._setRequestOptions();
    }
    return this.http.delete(url, options);
  }*/
  /**
   * @param options if options are not supplied the default content type is application/json
   */
  /*AuthPost(url: string, data: any, options?: RequestOptions): Observable<Response> {

    const body = JSON.stringify(data);

    if (options) {
      options = this._setRequestOptions(options);
    } else {
      options = this._setRequestOptions();
    }
    return this.http.post(url, body, options);
  }
*/

  private _setAuthHeaders(user: any): void {

    this.authHeaders = new Headers();
    this.authHeaders.append('Authorization', user.token_type + ' ' + user.access_token);
    if (this.authHeaders.get('Content-Type')) {

    } else {
      this.authHeaders.append('Content-Type', 'application/json');
    }
  }
  /*private _setRequestOptions(options?: RequestOptions) {
    if (this.loggedIn) {
      this._setAuthHeaders(this.currentUser);
    }
    if (options) {
      options.headers.append(this.authHeaders.keys[0], this.authHeaders.values[0]);
    } else {
      options = new RequestOptions({ headers: this.authHeaders });
    }

    return options;
  }
*/


addLockout(input) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(environment.apiUrl + 'LockOut/AddLockout', JSON.stringify(input), httpOptions);
  }

  updateLockout(input) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(environment.apiUrl + 'LockOut/UpdateLockout', JSON.stringify(input), httpOptions);
  }


  deleteLockout(id: any) {
    return this.http.delete<any>(environment.apiUrl + 'LockOut/DeleteLockOut/'+ id);
  }

getSystemLockOuts() {
  return this.http.get<any>(environment.apiUrl + 'LockOut/GetSystemLockOuts');
}

}

/*@Injectable()
export class AuthService {
  private loggedIn = new BehaviorSubject<boolean>(false); // {1}

  get isLoggedIn(): Observable<boolean> {
    this.loggedIn.next(sessionStorage.getItem('loggedin') === 'true');
   return this.loggedIn.asObservable(); // {2}

  }

  constructor(
    private router: Router
  ) {}

  login(user: User) {

    if (user.username !== '' && user.password !== '' ) { // {3}
      this.loggedIn.next(true);
      sessionStorage.setItem('loggedin', 'true');
      this.router.navigate(['']);
    }
  }

  logout() {                            // {4}
    this.loggedIn.next(false);
    this.router.navigate(['/login']);
  }
}*/


